import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { Button, Modal, Card ,  Form, Row, Col } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search,CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';
import { cloneDeep, isEmpty } from 'lodash';

import "./index.css";
import { fetchLocations } from '../../../Helpers/subSuperAdmin.api.js';
import { MODULE_LISTING_CONSTANT } from '../../../Helpers/constant.js';
class BulkLocationDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerId: '',
            sizePerPage: 10,
            selectedRows: [],
            confirmBulkDelete: false,
            confirmDeleteAll: false,
            groupList : [],
            groupId1 : "",
            userGroupList : [],
            locationList : [],
            locationId : '',
            userLocationList : [],
            swapLocationId:"",
            isSwap:false,
            loading: false,
            moduleListingData:props.app.moduleListingData
        }
    }
    componentDidMount() {
        this.getLocation();
    }

    getLocation = () => {
        const apiPath = this.props.app.apiPath;

        this.setState({ loading: true });
        fetchLocations({
            apiPath,
            userId: this.props.app.userId,
            isSubSuperAdmin:this.props.app.isSubSuperAdmin,
            moduleListingData: this.state.moduleListingData,
            filterKey: MODULE_LISTING_CONSTANT.MANAGE_LOCATIONS
        })
            .then(res => {
                this.setState({
                    locationList: res
                })
            })
            .finally(() => {
                this.setState({ loading: false });
            })
    }

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }


    confirmBulkDelete = (status) => {
        this.setState({
            confirmBulkDelete: status,
            confirmApprove: false,
            confirmReject: false,
            showListenModal: false
        });
    }

    confirmDeleteAll = (status) => {
        this.setState({
            confirmDeleteAll: status,
            confirmApprove: false,
            confirmReject: false,
            showListenModal: false
        });
    }


    filterLocation = (event) => {
        
        event.preventDefault();
        if(this.state.locationId === ''){
            Notify.notify("Please Select Location");
            return 
        }

        const data = {
                "locationId" : this.state.locationId
        }

        //this.state.voicelist = [];
        this.setState({ loading: true, userLocationList: [] });
        return Fetcher.post(this.props.app.apiPath + '/api/obd/user/location/list', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
                        .then(res => {
                                this.setState({
                                    userLocationList : res,
                                    loading: false,
                                })
                        })
                        .catch(err => {
                            console.log('Error in Fetching User Location', err);
                            Notify.notify('Error in Fetching User Location');
                            this.setState({ loading: false });
        });
    }


    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('voiceFileListsizePerPage', newSizePerPage);
    }

    handleSelectRow = (row, isSelect) => {
        this.setState(prevState => {
               const selectedRows = [...prevState.selectedRows];
               if (isSelect) {
                            selectedRows.push(row.userId);
               } else {
                        const index = selectedRows.indexOf(row.userId);
                        if (index > -1) {
                                    selectedRows.splice(index, 1);
                        }
                }
        return { selectedRows };
       });

    };

    handleSelectAll = (isChecked) => {
        if (isChecked) {
          const allUserIds = this.state.userLocationList.map((location) => location.userId);
          this.setState({ selectedRows: allUserIds });
        } else {
          this.setState({ selectedRows: [] });
        }
      };
      
      isSelectedAll = () => {
        const { selectedRows, userLocationList } = this.state;
        if (userLocationList.length === 0) return false;
        return selectedRows.length === userLocationList.length;
      };
      

    bulkDelete = () => {
        console.log("selectd : "+this.state.selectedRows);
        this.confirmBulkDelete(true);

    }

    allDelete = () => {
        this.confirmDeleteAll(true);
    }

    deleteAll = () => {
    
            let a = this.state.userGroupList.map(p => p.userId);
    
            console.log("------------- : "+a);
    
            if(a.toString().length===0){
                Notify.notify("Please Select Atleast Record");
                return;
            }
            const data = {
                "locationId": this.state.locationId,
                "userIds":a.toString()
            }
    
            return Fetcher.post(this.props.app.apiPath + '/api/obd/bulk/user/location/deletion', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
                .then(res => {
                    Notify.notify(res.message);
                    this.state.selectedRows= [];
                    this.state.locationId="";
                    setTimeout(() => {
                            window.location.reload(false);
                    }, 1000);
                })
                .catch(err => {
                    console.log('Error in Deleting Users Location', err);
                });
    }

    deleteBulk = () => {
            if (this.state.isSwap && !this.state.swapLocationId) {
                Notify.notify("Please select a group to swap");
                return;
            }
            let a = this.state.selectedRows.toString();
            const swapLocationId=this.state.swapLocationId
    
            console.log("------------- : "+a);
    
            if(a.toString().length===0){
                Notify.notify("Please Select Atleast Record");
                return;
            }
            const data = {
                "locationId": this.state.locationId,
                "userIds":a.toString(),
                "swapLocationId": this.state.isSwap ? swapLocationId : ""
            }
    
            return Fetcher.post(this.props.app.apiPath + '/api/obd/bulk/user/location/deletion', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
                .then(res => {
                    Notify.notify(res.message);
                    this.state.selectedRows= [];
                    this.state.locationId="";
                    setTimeout(() => {
                            window.location.reload(false);
                    }, 1000);
                })
                .catch(err => {
                    console.log('Error in Deleting Users Location', err);
                });
    }
    

    render() {
        const userLocations = this.state.userLocationList;
        let columns='';

        const { selectedRows } = this.state;
        columns = [
            {
                dataField: 'select',
                text: 'Select',
                headerFormatter: () => (
                  <input
                    type="checkbox"
                    checked={this.isSelectedAll()}
                    onChange={(e) => this.handleSelectAll(e.target.checked)}
                  />
                ),
                formatter: (cell, row) => (
                  <input
                    type="checkbox"
                    checked={this.state.selectedRows.includes(row.userId)}
                    onChange={(e) => this.handleSelectRow(row, e.target.checked)}
                  />
                ),
                headerStyle: { width: '50px' },
              },
              {
                dataField: 'userId',
                text: 'User Id',
                sort: true,
              },
              {
                dataField: 'username',
                text: 'User Name',
                sort: true,
              },
              {
                dataField: 'locationname',
                text: 'Location Name',
                sort: true,
                searchable: true,
              },
            {
                dataField: 'userId',
                text: 'User Id',
                sort: true,
                hidden: false
            },
            {
                dataField: 'username',
                text: 'User Name',
                sort: true,
                hidden: false
            },
            {
                dataField: 'locationname',
                text: 'Location Name',
                sort: true,
                searchable: true
            },
             ];
        
        
        const products = Array.isArray(userLocations) ? userLocations.map((location, index) => {
                return {
                    userId: location.userId,
                    username : location.username,
                    locationname : location.locationName
                };
        }) : []

       const lAList = cloneDeep(this.state.locationList);
       let locationDropdown = '';
       if (!isEmpty(lAList) && (!('error' in lAList))) {
             locationDropdown = Array.isArray(lAList) ? lAList.map((obj, index) => {
               return (
                      <option value={obj.locationId} key={`group${index}`} >{obj.locationName}</option>
                       );
                }) : [];
        } else {
            locationDropdown = <p>No Location found</p>;
        }

        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'userId',
            order: 'desc'
        }];

        const { ExportCSVButton } = CSVExport;

        const paginationOption = {
            custom: true,
            totalSize: products.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>Bulk User Location Deletion</Card.Header>
                <Card.Body>
                    <div className="campaign-list-table-cont">
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (<ToolkitProvider 
                                                    keyField="userId"
                                                    data={products}
                                                    columns={columns}
                                                    search bootstrap4>
                                    {props => (<div className="">
                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                        {/* <ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton> */}
                                        { (this.state.selectedRows.length >0 ) ? <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.bulkDelete()}>Bulk Delete</Button> : <></>}
                                        {/* { ((this.state.selectedRows.length ===0) && (this.props.app.role === 'ROLE_SADMIN') ) ? <a data-tip="Delete File" key={`delete-file`} className="float-right btn btn-default btn-success ml-2" onClick={(e) => { this.allDelete() }} href="#">Delete All</a> : <></>} */}
                                        <hr/>

                                        <Form method="post" onSubmit={this.filterLocation}>
                                            <Row>
                                                <Col sm ={4}>
                                                    <Form.Group className="form-group" >
                                                        <Form.Select as="select" required name="locationId" onChange={e => this.setvalue(e)}>
                                                            <option value="">Select Location</option>
                                                                    {locationDropdown}
                                                            </Form.Select>
                                                        </Form.Group>
                                                </Col>
                                                  
                                                <Col sm={4}>
                                                   <Button className="btn-round" variant="primary" type="submit" disabled={this.state.loading}>Filter</Button>
                                                </Col>
                                            </Row>
                                        </Form>

                                        <BootstrapTable 
                                                      key={this.state.selectedRows.join(',')}
                                                      bordered={true} 
                                                      condensed defaultSorted={defaultSorted}
                                                      wrapperClasses="table-responsive"
                                                      classes="voicelist-table" {...props.baseProps}
                                                       {...paginationTableProps} 
                                                       noDataIndication={() => (<div>{'No data available'}</div>)} 
                                                        />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>)}
                                </ToolkitProvider>)
                            }
                        </PaginationProvider>}
                    </div>
                     <Modal size="md" show={this.state.confirmBulkDelete} onHide={() => this.confirmBulkDelete(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete User Location
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete All User Location?

                            <Form.Check
                                type="checkbox"
                                id="swap-group-checkbox"
                                label="Do you want to swap locations?"
                                checked={this.state.isSwap}
                                onChange={(e) =>
                                    this.setState({
                                        isSwap: e.target.checked,
                                        swapLocationId: ""
                                    })
                                }
                                className="mb-3 mt-3"
                            />
                            {this.state.isSwap && (
                                <Col sm={8}>
                                    <Form.Group className="form-group">
                                        <Form.Select
                                            name="swapLocationId"
                                            value={this.state.swapLocationId}
                                            onChange={this.setvalue}
                                            required={this.state.isSwap}
                                            className='w-100'
                                        >
                                            <option value="">Select Group</option>
                                            {lAList.filter(el => el.locationId != this.state.locationId).map((obj, index) => {
                                                return (
                                                    <option value={obj.locationId} key={`group${index}`} >{obj.locationName}</option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmBulkDelete(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteBulk} variant="primary" disabled={this.state.isSwap && !this.state.swapLocationId}>YES</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.confirmDeleteAll} onHide={() => this.confirmDeleteAll(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete All User Location
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to Delete All User Location?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmDeleteAll(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteAll} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>
                    {this.state.loading && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
                </Card.Body>
            </Card>
        );
    }
}


export default BulkLocationDelete;